import { HStack, Text } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

type DiscountAppliedProps = {
  appliedPromoCodesAmount: number;
};

/**
 * The discount as a **price row**, matching the ticket-price and subtotal rows around it —
 * "خصم الرمز الترويجي  − 25,000 د.ع" (TZ-CO-8). It replaced a heavy green callout box, which read
 * as a separate widget bolted onto the price card rather than a line of the same bill.
 */
export const DiscountApplied = ({ appliedPromoCodesAmount }: DiscountAppliedProps) => {
  return (
    <HStack justify='space-between'>
      <Text variant='bodySmallRegular' color='green.G600'>
        <FormattedMessage
          id='checkout.promoCode.discountLine'
          defaultMessage='Promo code discount'
        />
      </Text>
      <Text variant='bodySmallRegular' color='green.G600'>
        −{new Intl.NumberFormat().format(appliedPromoCodesAmount)} د.ع
      </Text>
    </HStack>
  );
};
